import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminTasks from "@/pages/admin/AdminTasks";
import EntityManager from "@/pages/admin/EntityManager";
import { sar } from "@/lib/api";

const PROJECT_FIELDS = [
  { key: "name", label: "اسم المشروع", required: true },
  { key: "city", label: "المدينة", required: true },
  { key: "description", label: "الوصف", type: "textarea" },
  { key: "units_count", label: "عدد الوحدات", type: "number" },
  { key: "contract_end", label: "تاريخ انتهاء العقد", type: "date" },
  { key: "image", label: "رابط الصورة", placeholder: "/images/p1.jpg" },
  { key: "active", label: "متعاقد ومفعّل", type: "switch" },
];
const SERVICE_FIELDS = [
  { key: "name", label: "اسم الخدمة", required: true },
  { key: "description", label: "الوصف", type: "textarea" },
  { key: "icon", label: "الأيقونة", type: "select", options: ["arrow-up-down", "lightbulb", "droplets", "shield", "sparkles", "wrench"] },
  { key: "active", label: "مفعّلة", type: "switch" },
];
const PRODUCT_FIELDS = [
  { key: "name", label: "اسم المنتج", required: true },
  { key: "category", label: "التصنيف", required: true, placeholder: "إضاءة / صنابير / سباكة" },
  { key: "price", label: "السعر (ر.س)", type: "number" },
  { key: "installation_fee", label: "رسوم التركيب (ر.س)", type: "number" },
  { key: "description", label: "الوصف", type: "textarea" },
  { key: "image", label: "رابط الصورة", placeholder: "/images/bulb1.jpg" },
  { key: "active", label: "معروض في المتجر", type: "switch" },
];

const TABS = [
  ["overview", "نظرة عامة", <AdminOverview />],
  ["owners", "الملاك والاعتماد", <AdminUsers mode="owners" />],
  ["employees", "الموظفون والصلاحيات", <AdminUsers mode="staff" />],
  ["projects", "المشاريع", <EntityManager resource="projects" title="المشاريع السكنية" fields={PROJECT_FIELDS} columns={[["name", "المشروع"], ["city", "المدينة"], ["units_count", "الوحدات"]]} />],
  ["maintenance", "طلبات الصيانة", <AdminTasks kind="maintenance" />],
  ["orders", "طلبات المتجر", <AdminTasks kind="orders" />],
  ["products", "المنتجات والأسعار", <EntityManager resource="products" title="منتجات المتجر" fields={PRODUCT_FIELDS} columns={[["name", "المنتج"], ["category", "التصنيف"], ["price", "السعر", sar], ["installation_fee", "التركيب", sar]]} />],
  ["services", "خدمات الملاك", <EntityManager resource="services" title="أنواع خدمات الصيانة المشتركة" fields={SERVICE_FIELDS} columns={[["name", "الخدمة"], ["description", "الوصف"]]} />],
];

export default function AdminDashboard() {
  return (
    <div data-testid="admin-dashboard">
      <PageHeader title="لوحة الإدارة" subtitle="إدارة المشاريع والملاك والموظفين والخدمات والطلبات" />
      <Tabs dir="rtl" defaultValue="overview">
        <TabsList className="mb-8 flex h-auto w-full flex-nowrap justify-start gap-1 overflow-x-auto bg-white border border-[#E5DEC9] p-1.5">
          {TABS.map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`} className="whitespace-nowrap rounded-md data-[state=active]:bg-[#0F382C] data-[state=active]:text-white">{l}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([v, , el]) => <TabsContent key={v} value={v}>{el}</TabsContent>)}
      </Tabs>
    </div>
  );
}
